import React, { useState } from 'react'

const FaqAccordion = ({ title, content }) => {
  const [isActive, setIsActive] = useState(false)

  const formattedContent = content.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {line}
      <br />
    </React.Fragment>
  ))

  return (
    <div className={`accordion-section mt-2 mb-2 shadow-md ${isActive ? 'accordion-active' : ''}`}>
      <div className="accordion-title" onClick={() => setIsActive(!isActive)}>
        <div>{title}</div>
        <div>{isActive ? '-' : '+'}</div>
      </div>
      {isActive && <div className="accordion-content">{formattedContent}</div>}
    </div>
  )
}

export default FaqAccordion
